module.exports = __webpack_public_path__ + "static/media/Union.41ba888d.svg";